import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/about/up.svg';
import _imports_1 from '@/assets/imgs/about/down.svg';
const _withScopeId = n => (_pushScopeId("data-v-4fce6c87"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "qa decoration flex flex-col justify-center items-center py-32"
};
const _hoisted_2 = {
  class: "container mx-a px-5"
};
const _hoisted_3 = {
  class: "text-5xl font-medium mb-5 text-center"
};
const _hoisted_4 = {
  class: "text-gray6 text-center"
};
const _hoisted_5 = {
  class: "mt-20 flex flex-col items-center container mx-a px-5"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "font-medium mr-2"
};
const _hoisted_8 = {
  key: 0,
  src: _imports_0
};
const _hoisted_9 = {
  key: 1,
  src: _imports_1
};
const _hoisted_10 = {
  class: "w-0 h-0 overflow-hidden text-sm"
};
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'QA',
  props: {
    name: String,
    length: Number
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const qa = ref([]);
    const clickShow = (isShow, i) => {
      qa.value = new Array(props.length).fill(false);
      qa.value[i] = !isShow;
    };
    onMounted(() => {
      qa.value = new Array(props.length).fill(false);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)(`about.qa.title`)), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)(`about.qa.desc`)), 1), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.value, (isShow, i) => {
        return _openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass(['mb-4 px-8 py-5 rounded w-full overflow-hidden bg-white', isShow && 'show'])
        }, [_createElementVNode("div", {
          class: "flex justify-between items-center cursor-pointer",
          onClick: $event => clickShow(isShow, i)
        }, [_createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(t)(`${__props.name}.qa.list[${i}].q`)), 1), isShow ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9))], 8, _hoisted_6), _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)(`${__props.name}.qa.list[${i}].a`)), 1)], 2);
      }), 128))])])]);
    };
  }
});